var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatar2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_9287)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "#C6E4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 14.5C29 17.2403 28.2397 19.8028 26.9178 21.9888C25.5777 24.2086 23.6578 26.0391 21.3687 27.2725C19.3248 28.3746 16.9856 29 14.5005 29C12.0153 29 9.67518 28.3746 7.63038 27.2725C5.34218 26.0391 3.42228 24.2086 2.08126 21.9888C0.760303 19.8028 0 17.2403 0 14.5C0 6.49246 6.49175 0 14.5005 0C22.5092 0 29 6.49246 29 14.5Z",
    fill: "#C6E4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9043 11.0683C12.9043 9.16768 11.3635 7.62695 9.4629 7.62695C7.56226 7.62695 6.02148 9.16768 6.02148 11.0683V21.0048C6.02148 22.9054 7.56226 24.4461 9.4629 24.4461C11.3635 24.4461 12.9043 22.9054 12.9043 21.0048V11.0683Z",
    fill: "#EC4A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9776 11.0683C22.9776 9.16768 21.4368 7.62695 19.5361 7.62695C17.6355 7.62695 16.0947 9.16768 16.0947 11.0683V21.0048C16.0947 22.9054 17.6355 24.4461 19.5361 24.4461C21.4368 24.4461 22.9776 22.9054 22.9776 21.0048V11.0683Z",
    fill: "#FB6514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46253 13.2208C10.6769 13.2208 11.6614 12.2364 11.6614 11.022C11.6614 9.80768 10.6769 8.82324 9.46253 8.82324C8.24814 8.82324 7.26367 9.80768 7.26367 11.022C7.26367 12.2364 8.24814 13.2208 9.46253 13.2208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5363 13.2208C20.7507 13.2208 21.7351 12.2364 21.7351 11.022C21.7351 9.80768 20.7507 8.82324 19.5363 8.82324C18.3219 8.82324 17.3374 9.80768 17.3374 11.022C17.3374 12.2364 18.3219 13.2208 19.5363 13.2208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5005 17.7988V28.9997C16.9856 28.9997 19.3249 28.3744 21.3687 27.2722C23.6579 26.0388 25.5778 24.2083 26.9179 21.9886C23.4719 19.3604 19.169 17.7988 14.5005 17.7988Z",
    fill: "#FB6514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08148 21.9886C3.42249 24.2083 5.34239 26.0388 7.6306 27.2722C9.67539 28.3744 12.0156 28.9997 14.4998 28.9997V17.7988C9.83128 17.7988 5.52654 19.3604 2.08057 21.9886H2.08148Z",
    fill: "#EC4A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46285 12.3319C10.1864 12.3319 10.7729 11.7454 10.7729 11.0219C10.7729 10.2984 10.1864 9.71191 9.46285 9.71191C8.73935 9.71191 8.15283 10.2984 8.15283 11.0219C8.15283 11.7454 8.73935 12.3319 9.46285 12.3319Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3989 12.3319C20.1224 12.3319 20.7089 11.7454 20.7089 11.0219C20.7089 10.2984 20.1224 9.71191 19.3989 9.71191C18.6754 9.71191 18.0889 10.2984 18.0889 11.0219C18.0889 11.7454 18.6754 12.3319 19.3989 12.3319Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_9287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar2);
export default __webpack_public_path__ + "static/media/default-avatar-2.ff675935b0bf3b1cd95c81e31e661943.svg";
export { ForwardRef as ReactComponent };